<template>
  <div class="max-w-screen-2xl mx-auto py-2 sm:px-2 lg:px-2">
    <div class="flex justify-center h-24">
      <div class="absolute left-44">
        <img
          src="/images/logo.png"
          alt="logo"
          class="fluid"
        >
      </div>
      <div class="text-4xl my-auto">Entrevista de desligamento</div>
    </div>
    <div class="grid grid-cols-1 py-4">
      <div class="col-span-1">Filial/Matrícula: {{entrevista.funcionario_id | VMask("####/#####")}}</div>
      <div class="col-span-1">Nome: {{entrevista.nome}}</div>
      <div class="col-span-1">Função: {{  entrevista.funcao_nome}}</div>
    </div>
    <div>
        <div class="col-span-12">
            <div class="p-4 bg-red-700 text-white my-4 text-xl font-semibold">
                Qual seguimento étnico e racial com que você se identifica
            </div>
            <div class="p-4">
                {{entrevista.seguimento_etnico}}
            </div>
        </div>

        <div
        v-if="entrevista.demissao_solicitada_por ==='FUNCIONARIO'"
        class="col-span-12"
      >
        <div class="p-4 bg-red-700 text-white text-xl font-semibold"> Motivos de desligamento</div>
        <div class="p-4">
          <ul>
            <li
              v-for="motivo in  entrevista.motivo_desligamento"
              :key="motivo.id"
              class="py-1"
            > <span>{{motivo.nome}}</span> </li>
          </ul>
        </div>
      </div>
      <div
        v-for="secao in questionario.secoes"
        :key="secao.id"
        class="flex flex-col "
      >
        <div class="p-4 bg-red-700 text-white text-xl font-semibold">{{secao.nome}}</div>
        <div>
          <div
            v-for="pergunta in secao.perguntas"
            :key="pergunta.id"
            class="grid grid-cols-5 even:bg-gray-100   py-8 px-2"
          >
            <div class="col-span-3">
              {{pergunta.enunciado}}
            </div>
            <div
              v-if="temRespostas"
              class="col-span-2 flex flex-col"
            >
              <div>
                {{  respostas[pergunta.id].resposta}}
              </div>
              <div>
                {{   respostas[pergunta.id].justificativa}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import CheckGroup from '@/Components/CheckGroup.vue';
import JetInputError from '@/Jetstream/InputError';
export default {
  name: 'EntrevistaDownloadShow',
  props: {
    entrevista: Object,
    questionario: Object,
    respostas: Object | Array,
  },
  components: { CheckGroup, JetInputError, },
  data() {
    return {

      form: this.$inertia.form({
        'entrevista_id': this.entrevista.id,
        'motivos': []
      })
    }
  },
  computed: {
    temRespostas() {
      return this.respostas && Object.keys(this.respostas).length > 0;
    }
  }

}
</script>

<style>
</style>
